import React from "react";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";

import ChevronIcon from "components/Icons/ChevronIcon";

type Props = {
  currentPage: number;
  customPath?: string;
  onNext: () => void;
  onPrev: () => void;
  totalPages: number;
};

const PageNavigation: React.FC<Props> = ({
  currentPage,
  customPath,
  onNext,
  onPrev,
  totalPages,
}) => {
  const { asPath } = useRouter();

  if (totalPages < 2) {
    return <></>;
  }

  const path = customPath || `${asPath.split("?")[0]}?page=`;
  const prevUrl = `${path}${currentPage - 1}`;
  const nextUrl = `${path}${currentPage + 1}`;

  // @ts-ignore (fix me please, do not replicate)
  const prevClick = (event) => {
    event.preventDefault();
    onPrev();
  };

  // @ts-ignore (fix me please, do not replicate)
  const nextClick = (event) => {
    event.preventDefault();
    onNext();
  };

  return (
    <>
      <Head>
        {currentPage > 1 && <link rel="prev" href={prevUrl} />}
        {currentPage < totalPages && <link rel="next" href={nextUrl} />}
      </Head>
      <nav
        data-testid="pagination-controls"
        aria-label="Navigate between pages"
      >
        <div className="flex justify-between my-xl w-100">
          <div className="flex justify-start flex-1">
            {currentPage > 1 && (
              <Link
                href={prevUrl}
                className="text-green"
                onClick={prevClick}
                data-testid="prev"
              >
                <ChevronIcon className="inline-block" direction="left" />
                Previous
              </Link>
            )}
          </div>
          <div className="flex justify-center flex-1" data-testid="page">
            {`${currentPage} of ${totalPages}`}
          </div>
          <div className="flex justify-end flex-1">
            {currentPage < totalPages && (
              <Link
                href={nextUrl}
                className="text-green"
                onClick={nextClick}
                data-testid="next"
              >
                Next
                <ChevronIcon className="inline-block" direction="right" />
              </Link>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default PageNavigation;
